import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import flashTokens from "@amzn/meridian-tokens/base/icon/flash";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import LogManager from "../../utils/logManager";
import { THEME_COLOR } from "../../styles/colors";
import { PROMPT_TYPE } from "./assistant.constants";
import mentionIcon from "../../images/mention.svg";

const PROMPT_BUTTONS = [
  { id: "catchMeUp", label: "Catch me up", icon: flashTokens, promptType: PROMPT_TYPE.CATCH_ME_UP },
  { id: "nameMentioned", label: "Was my name mentioned", iconSrc: mentionIcon, promptType: PROMPT_TYPE.WAS_MY_NAME_MENTIONED },
  { id: "whosWho", label: "Who's who", icon: userTokens, promptType: PROMPT_TYPE.WHOS_WHO },
];

const AssistantOptions = ({ onOptionSelect, alias, isWhosWhoEnabled }) => {
  const buttons = PROMPT_BUTTONS.filter(
    (btn) => btn.promptType !== PROMPT_TYPE.WHOS_WHO || isWhosWhoEnabled === true
  );

  const handleClick = (btn) => {
    LogManager.metric(`Assistant_PromptButton_${btn.id}_Click`, 1, alias ? { alias } : {});
    onOptionSelect && onOptionSelect(btn.label, btn.promptType);
  };

  return (
    <Column width="318px" spacing="400">
      <Text type="h200" alignment="start">
        Just tune in? Here's the story so far.
      </Text>
      <Column spacing="300">
        {buttons.map((btn) => (
          <Theme key={btn.id} tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, buttonSpacingInsetHorizontalXlarge: 0, buttonSpacingInsetVerticalXlarge: 0, buttonHeightXlarge: 44 }}>
            <Button type="icon" size="xlarge" onClick={() => handleClick(btn)}>
              <Box type="outline" width="318px" height="44px">
                <Column alignmentVertical="center" height="44px" spacingInset="none 300">
                  <Row spacing="300" alignmentVertical="center">
                    {btn.iconSrc
                      ? <img src={btn.iconSrc} alt="" width="20" height="20" />
                      : <Icon tokens={btn.icon} color="secondary" />}
                    <Text type="b200" color="secondary">{btn.label}</Text>
                  </Row>
                </Column>
              </Box>
            </Button>
          </Theme>
        ))}
      </Column>
    </Column>
  );
};

export default AssistantOptions;
